import { Component, Input } from '@angular/core';
import { Announcement } from '../../models/api/core/announcements/announcement';
import { SanitizerBypassHtmlPipe } from '../../pipes/sanitizer-bypass.pipe';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-announcements',
  imports: [SanitizerBypassHtmlPipe],
  template: `
    @for (item of announcements; track $index) {
      <h1 class="title">{{ item.title }}</h1>
      <p [innerHTML]="item.message | sanitizerBypassHtml"></p>
      <hr />
      <br />
    }
  `,
  styles: `
    .title {
      font-weight: bold;
      font-size: 17px;
      margin-bottom: 5px;
    }
  `,
})
export class AnnouncementsComponent extends BaseComponent {
  @Input()
  announcements: Announcement[];
}
